<template>
    <div class="edit-default">
        <img class="xiaoyue-pic" :src="xiaoyueIcon" />
        <p>{{ tips }}</p>
    </div>
</template>

<script>
export default {
    name: "Default",
    data() {
        return {
            xiaoyueIcon: this.zhiji.staticPath() + "xiaoyue-pic.png"
        };
    },
    computed: {
        tips() {
            return this.$t("zhiji.knowlege.quesEditModal.selectLeft");
        }
    }
};
</script>

<style lang="scss" scoped>
.edit-default {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 100%;
    background: #fff;
    font-size: 16px;

    .xiaoyue-pic {
        margin-bottom: 15px;
    }
}
</style>
